module.exports = __webpack_public_path__ + "Server-Unknown-TentaclePassive.e5cb1b3f89ac54c7375f6759c008c7a4.hashedasset.svg";